function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "alert"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M16.5 0C7.40154 0 0 7.40154 0 16.5C0 25.5985 7.40154 33 16.5 33C25.5985 33 33 25.5985 33 16.5C33 7.40154 25.5985 0 16.5 0Z",
  fill: "#009FE4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  d: "M17.875 24.7499C17.875 25.5093 17.2594 26.1248 16.5 26.1248C15.7407 26.1248 15.1251 25.5093 15.1251 24.7499C15.1251 23.9906 15.7407 23.375 16.5 23.375C17.2594 23.375 17.875 23.9906 17.875 24.7499Z",
  fill: "#ECEFF1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  d: "M17.875 19.25C17.875 20.0088 17.2591 20.6249 16.5 20.6249C15.741 20.6249 15.1251 20.0088 15.1251 19.25V8.24992C15.1251 7.49083 15.741 6.875 16.5 6.875C17.2591 6.875 17.875 7.49083 17.875 8.24992V19.25Z",
  fill: "#FAFAFA"
}));

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.180dfc77.svg";
export { ForwardRef as ReactComponent };